.RSACContainer
    position: relative
    max-width: 420px
    width: 100%
    margin: 0 auto
    display: flex
    flex-direction: column
    border-radius: $globalSettingsRounding
    background: rgb($globalSettingsBackgroundPrimary)
    overflow: hidden
    box-shadow: 0 2px 10px 0 rgba($globalSettingsBackgroundShadowColor,0.05)
    &:hover
        box-shadow: 0 10px 20px 0 rgba($globalSettingsBackgroundPrimary, 0.10)
    @media #{$tablet}
        margin: 0
        width: 320px
    .RSACGallery
        width: 100%
        aspect-ratio: 4 / 3
        overflow: hidden
        flex-shrink: 0
        @media #{$tablet}
            width: 320px
            height: 240px
    .RSACGallerySkeleton
        background: rgb($globalSettingsBackgroundTertiary)
    .RSACFooter
        position: relative
        width: 100%
        height: 75px
        min-height: 0
        display: flex
        flex-direction: column
        flex-grow: 1
        .RSACInfoContainer
            width: 100%
            height: 80px
            padding: 0 20px
            display: flex
            flex-direction: row
            justify-content: space-between
            align-items: center
            gap: 10px
            cursor: pointer
            &:hover
                .RSACArrowSvg
                    stroke: rgb($globalSettingsFontPrimary)
        .RSACInfo
            min-width: 0
            display: flex
            flex-direction: column
            .RSACName
                font-size: 16px
            .RSACNameSkeleton
                width: 100px
                height: 20.5px
                background: rgb($globalSettingsBackgroundTertiary)
                border-radius: $globalButtonRounding
            .RSACTitleSkeleton
                width: 150px
                height: 16.5px
                margin-top: 4px
                background: rgb($globalSettingsBackgroundTertiary)
                border-radius: $globalButtonRounding
            span
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
        .RSACArrowSvg
            stroke: rgb($globalSettingsFontSecondary)
            transform: rotateZ(-90deg)
        .RSACButton
            width: 100%
            flex: 1
            padding: 0 20px
            display: flex
            flex-direction: row
            justify-content: space-between
            align-items: center
            gap: 10px
            .RSACMore
                cursor: pointer
                text-decoration: underline
                &:hover
                    color: rgb($globalSettingsFontSecondary)
                &:active
                    color: rgba($globalSettingsFontTertiary, 0.8)
            .RSACMoreSkeleton
                width: 120px
                height: 16.5px
                background: rgb($globalSettingsBackgroundTertiary)
                border-radius: $globalButtonRounding
            .RSACPriceSkeleton
                width: 80px
                height: 16.5px
                background: rgb($globalSettingsBackgroundTertiary)
                border-radius: $globalButtonRounding
            .RSACPrice
                font-weight: 700
                font-size: 12px
            .RSACPriceAction
                background: rgb($globalButtonBackgroundPrimary)
                color: rgb($globalButtonFontPrimary)
                border-radius: $globalButtonRounding

                cursor: pointer
                &:hover
                    background: rgb($globalButtonBackgroundSecondary)
                &:active
                    background-color: rgb($globalButtonBackgroundPrimary)
